module.exports = __webpack_public_path__ + "static/img/rank_304.f14ef2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_304.png
// module id = NVI/
// module chunks = 1